(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery', 'app/applicationUtils', 'app/utils/stringUtils'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory(require('jquery'), require('./../applicationUtils'), require('./stringUtils'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function($, applicationUtils, stringUtils) {
  'use strict';

  /**
   * Utility methods for checking whether an i18n message exists
   *
   * @class i18nUtils
   * @static
   */
  return {
    /**
     * @param  {String}  i18nKey property key to be checked
     * @return {Boolean}         whether or not the i18n key returns a property value
     */
    hasPropertyValue: function(i18nKey) {
      var message = this.getI18nPropertyValue(i18nKey);
      return message.indexOf('[' + i18nKey + ']') !== 0 && !!message.trim();
    },

    /**
     * @param  {String} i18nKey property key to be checked
     * @return {Boolean}        whether or not the i18n key returns a link
     *                          that is external to the patient-portal application
     *                          A link provided in the i18nKey must start with "http://"
     *                          or "https://" and contains no white space to be determined
     *                          as an external link here.
     */
    containsExternalLink: function(i18nKey) {
      if (this.hasPropertyValue(i18nKey)) {
        var link = this.getI18nPropertyValue(i18nKey);
        var isHttp = stringUtils.startsWith(link, 'http://');
        var isHttps = stringUtils.startsWith(link, 'https://');
        var hasNoWhiteSpace = link.indexOf(' ') === -1;
        var isExternalLink = (isHttp || isHttps) && hasNoWhiteSpace;
        if (applicationUtils.isInternalLink(link)) {
          return false;
        } else if (isExternalLink) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    /**
     * @param  {String} i18nKey property key
     * @return {Object} i18n key property value
     */
    getI18nPropertyValue: function(i18nKey) {
      return $.i18n.prop(i18nKey);
    }
  };
}));
